// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__nhO19","container":"Image_container__a+v3c","image":"Image_image__TYCtg"};